import { ReactNode, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useNotification } from "../../context/NotificationContext";
import { Spinner } from "@nextui-org/react";
import "../../styles/styles.css";
import { useClientPrincipal } from "../../context/ClientPrincipalContext";

type ProtectedRouteProps = {
  children: ReactNode;
};

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { clientPrincipal, isLoading } = useClientPrincipal();
  const { setNotification } = useNotification();
  const location = useLocation();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      setChecked(true);
    }
  }, [isLoading]);

  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === "wasLoggedOut" && e.newValue === "true") {
        if (!sessionStorage.getItem("logoutNotified")) {
          setNotification({
            type: "info",
            message: "You have been logged out from another tab.",
          });
          sessionStorage.setItem("logoutNotified", "true");
        }

        setTimeout(() => {
          window.location.href = "/login";
        }, 1000);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [setNotification]);

  if (!checked) {
    return (
      <div className="centered-loading">
        <Spinner size="lg" label="Checking authentication..." />
      </div>
    );
  }

  if (clientPrincipal === null) {
    if (!sessionStorage.getItem("sessionExpiredNotified")) {
      setNotification({
        type: "error",
        message: "Please log in to access this page.",
      });
      sessionStorage.setItem("sessionExpiredNotified", "true");
    }

    const currentPath = location.pathname + location.search;
    const loginPath = currentPath !== "/" ? `/login?redirect=${encodeURIComponent(currentPath)}` : "/login";
    return <Navigate to={loginPath} replace />;
  }

  sessionStorage.removeItem("sessionExpiredNotified");
  sessionStorage.removeItem("logoutNotified");

  return <>{children}</>;
};

export default ProtectedRoute;
